import { useState } from 'react';

const faqs = [
  {
    q: 'YY免费漫画真的免费吗？',
    a: '是的，YY免费漫画平台上的热门连载与经典完结漫画均可直接免费阅读，无需下载、无需注册即可打开。',
  },
  {
    q: '为什么选择下拉式翻页阅读？',
    a: '下拉式翻页更符合手机阅读习惯，一屏一图连贯滚动，翻页流畅无卡顿，网页版即开即读，比传统翻页更省时。',
  },
  {
    q: '网页版看漫画会不会伤眼？',
    a: 'YY免费漫画提供高清画质与舒适阅读模式，支持亮度调节与夜间模式，降低长时间阅读的视觉疲劳。',
  },
  {
    q: '需要下载App才能看吗？',
    a: '不需要。YY免费漫画网页版即开即读，电脑、平板、手机浏览器均可直接打开阅读，随时随地免费追。',
  },
  {
    q: '书签和阅读进度会同步吗？',
    a: '会的。阅读进度会自动保存为智能书签，即使换设备或刷新页面，也能从上次停下的地方继续阅读。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100/40 py-12 md:py-16">
      <div className="mx-auto max-w-3xl px-4 md:px-6 lg:px-8">
        <div className="mb-8 text-center">
          <h2 className="flex items-center justify-center gap-2 font-heading text-2xl text-foreground-950">
            <i className="ri-question-line text-primary-500" />
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-600">关于 YY免费漫画 的疑问，这里都有答案</p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const open = openIndex === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-lg bg-background-100 ring-1 transition ${
                  open ? 'ring-primary-500/40' : 'ring-background-200/70'
                }`}
              >
                <button
                  onClick={() => setOpenIndex(open ? null : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <span className={`text-sm font-bold ${open ? 'text-primary-400' : 'text-foreground-950'}`}>
                    {f.q}
                  </span>
                  <i
                    className={`shrink-0 text-foreground-500 transition-transform duration-300 ${
                      open ? 'rotate-180 text-primary-400' : ''
                    } ${open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}
                  />
                </button>
                <div className={`grid transition-all duration-300 ${open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 pb-4 text-sm leading-6 text-foreground-600">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}